module.exports = __webpack_public_path__ + "img/logo-text_aurus.e268a414.svg";